<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('PPDbContacts.SelectPatientTitle')"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Continue'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <div>
            <b-row>
                <b-col>
                    <MdLookup
                        v-bind:Label="$tc('Shared.Patient', 1)"
                        v-bind:ModelCode="patientCode"
                        v-bind:ModelDescription="patientName"
                        v-bind:RefCode="'patientcode'"
                        v-bind:Api="'Patients'"
                        v-bind:FieldCode="'patientcode'"
                        v-bind:FieldDescription="'firstname'"
                        :SearchTitle="$tc('Shared.Patient', 1)"
                        :GetValues="getValues"
                        :InvalidFeedback="$t('Msg.InvalidCode')"
                        v-bind:isValid="isPatientValid"
                        v-bind:isRequired="true"
                    />
                </b-col>
            </b-row>
        </div>
    </BaseModal>
</template>

<script>
export default {
    name: 'PatientPortalSelectPatient',
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalSelectPatientModal',
            emitCloseEvent: false,
            patientCode: '',
            patientName: '',
            isPatientValid: true
        };
    },
    methods: {
        resetData() {
            this.patientCode = '';
            this.patientName = '';
            this.isPatientValid = true;
        },

        getValues(value) {
            this.patientCode = value ? value.code : '';
            this.patientName = value ? value.description : '';
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            this.isPatientValid = !!this.patientCode;

            if (this.isPatientValid) {
                this.$nextTick(() => {
                    this.$emit('update:visible', false);
                    this.$emit('ok', this.patientCode);
                    this.resetData();
                });
            } else {
                bvModalEvent.preventDefault();
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        }
    }
};
</script>
